import React from 'react'
import './Myskills.scss'
export default function Myskills() {
  return (
    <>
       <div className="container-fluid" id='skiils-cf'>
        <div className="container py-5" id='skills-c'>
            <h3 className='py-4'>My Skills</h3>
            <div className="col" id='skill-wrap'>
                <h4>Frontend Tech</h4>
                <div className="row">
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>HTML/HTML5</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>CSS/CSS3</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>JavaScript</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Bootstrap</b></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col" id='skill-wrap'>
                <h4>Backend Tech</h4>
                <div className="row">
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>PHP</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Node JS</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Express</b></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col" id='skill-wrap'>
                <h4>Database Tech</h4>
                <div className="row">
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>MySQL</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>SQL</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>MongoDB</b></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col" id='skill-wrap'>
                <h4>Framework Tech</h4>
                <div className="row">
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>React JS</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Angular JS</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Bootstrap-4 & Bootstrap-5</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Laravel</b></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col" id='skill-wrap'>
                <h4>Programming Skills</h4>
                <div className="row">
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>C</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>C++</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>C#</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Java</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Python</b></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col" id='skill-wrap'>
                <h4>UI & UX </h4>
                <div className="row">
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Adobe XD</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Adobe Photoshop</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Canva</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Figma</b></p>
                        </div>
                    </div>  
                </div>
            </div>
            <div className="col" id='skill-wrap'>
                <h4>Tools & Software </h4>
                <div className="row">
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Git & Github</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Postman</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>VS-code</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Android Studio</b></p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="col" id="skills">
                            <p><b>Lens studio</b></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       </div>
    </>
  )
}
